// extracted by mini-css-extract-plugin
export default {"rolledList__header":"RolledList_rolledList__header__sp51t","rolledList":"RolledList_rolledList__U6cxm","expandBtn":"RolledList_expandBtn__y88Hy","opened":"RolledList_opened__tbVEI"};